import { jsx as _jsx } from "react/jsx-runtime";
import { ArcElement, Chart, Legend, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';
Chart.register(ArcElement, Tooltip, Legend);
const COLORS = [
    '#2264DC',
    '#1A8FE3',
    '#55A1E5',
    '#0086C3',
    '#00A8A9',
    '#34C759',
    '#8BC34A',
    '#F4B400',
    '#FF6D00',
    '#FF3B30',
    '#D81B60',
    '#9C27B0',
    '#673AB7',
    '#7E57C2',
    '#795548',
    '#607D8B'
];
const PieChart = (props) => {
    if (!props.data || !props.data.length) {
        return null;
    }
    const data = {
        datasets: [
            {
                data: props.data.filter(d => d[props.valueKey]),
                hoverOffset: 16,
                hoverBorderColor: 'transparent',
                backgroundColor: COLORS
            }
        ]
    };
    const options = {
        parsing: {
            key: props.valueKey.toString()
        },
        responsive: true,
        plugins: {
            legend: {
                labels: {
                    font: {
                        size: 18
                    },
                    generateLabels: (chart) => {
                        return chart.data.datasets[0].data
                            .map((d, index) => ({
                            text: props.formatLabel ? props.formatLabel(d) : `${d[props.labelKey]}`,
                            fillStyle: COLORS[index],
                            borderRadius: 4,
                            lineWidth: 0
                        }));
                    }
                },
                position: props.legendPosition || 'bottom',
                onClick: () => { }
            },
            tooltip: {
                displayColors: false,
                backgroundColor: 'white',
                bodyColor: 'black',
                callbacks: {
                    label: (tooltipItem) => {
                        const data = tooltipItem.dataset.data[tooltipItem.dataIndex];
                        return props.formatLabel ? props.formatLabel(data) : `${(data)[props.labelKey]}`;
                    },
                }
            }
        }
    };
    return (_jsx(Pie, { data: data, options: options }));
};
export default PieChart;
